import { request } from "@insite/client-framework/Services/ApiService";

export function customCampaignForm(body: any) {
    return request(
        "api/v1/vmilead",
        "POST",
        { "Content-Type": "application/json" },
        JSON.stringify(body) as any,
    );
}
